import { HttpHandlerFn, HttpRequest } from '@angular/common/http';
import { inject } from '@angular/core';
import { AuthService } from '../services/auth/auth.service';
import { TokenProviderService } from '../services/token-provider/token-provider.service';

// X-Access-Token = Okta access token (BFF validates this with @okta/jwt-verifier).
// X-Token (casbin path only) = backend-issued JWT (the /api/v1/user/policy
// endpoint reads it to identify the user).
export function tokenInterceptor(
  req: HttpRequest<unknown>,
  next: HttpHandlerFn,
) {
  const oktaAccessToken =
    inject(TokenProviderService).accessToken()?.accessToken;

  if (!oktaAccessToken) {
    return next(req);
  }

  const headers = req.headers.append('X-Access-Token', oktaAccessToken);

  if (req.url.includes('auth/permissions')) {
    const backendToken = inject(AuthService).accessToken();
    return next(
      req.clone({
        headers: backendToken
          ? headers.append('X-Token', backendToken)
          : headers,
      }),
    );
  }

  return next(req.clone({ headers }));
}
